export default "__VITE_ASSET__CgXs8xXH__"